import store, { resetStores } from 'src/store'

export function logoutHandlerBusiness() {
  const languageCode = sessionStorage.getItem('languageCode')

  sessionStorage.clear()
  localStorage.removeItem('token')
  localStorage.removeItem('accessTokenExpiry')
  localStorage.removeItem('authorities')
  localStorage.removeItem('FCMToken')
  localStorage.removeItem('submittedFCMTokenForThisUser')
  localStorage.removeItem('lastChosenFlow')

  sessionStorage.setItem(
    'languageCode',
    languageCode ? languageCode : navigator?.language || navigator?.userLanguage?.split('-')[0],
  )

  store.dispatch(resetStores())
}
